import React, { useEffect } from 'react'
import { useMain } from '../../Hook/Main'
import Layout from '../../Layout'
import Item from '../../Components/Item'
import Loading from '../../Components/Loading'
import HeaderMain from '../../Components/HeaderMain'
function Index() {
    const { data, Request, loading } = useMain();
  
    const { favorites } = data
    useEffect(() => {
        Request({
            url: "/favorites",
            loading: "favorites"
        })
    }, [])

    return (
        <Layout>
            <HeaderMain lable="آگهی های پسندیده" />
            <div className="list-main main" style={{ paddingTop: '4rem' }}>
                {
                    loading.favorites ?
                        <Loading count={3} height={120} className="my-3" radius={10} />
                        :
                        favorites && favorites.length ? favorites.map((item, i) => {
                            if (item) {
                                if (item.item) {
                                    return <Item item={item.item} key={i} link={"/item/" + item.item.id} />;
                                }
                            }

                        }) :
                            <div className='text-center'>
                                <p>موردی انتخاب نشده</p>
                            </div>
                }
            </div>
        </Layout>
    )
}

export default Index